// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2DT6G","boxTitle":"Qualiphy_boxTitle__1gVOq","box":"Qualiphy_box__12L46","toggleWrap":"Qualiphy_toggleWrap__1Po4K"};